export async function getTransactionFee(client, { txId }) {
    const data = await client.request({
        method: 'getTransactionFee',
        params: { txId },
    });
    return data;
}
//# sourceMappingURL=getTransactionFee.js.map